import { render, staticRenderFns } from "./lista-listado-paginacion.vue?vue&type=template&id=41c62522&scoped=true&"
import script from "./lista-listado-paginacion.vue?vue&type=script&lang=ts&"
export * from "./lista-listado-paginacion.vue?vue&type=script&lang=ts&"
import style0 from "./lista-listado-paginacion.vue?vue&type=style&index=0&id=41c62522&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41c62522",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VPagination } from 'vuetify/lib/components/VPagination';
installComponents(component, {VPagination})
